

import LoadingSpinner from './LoadingSpinner';

const PageLoader = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center">
                <LoadingSpinner />
                <p className="mt-4 text-gray-500 text-sm animate-pulse">Cargando...</p>
            </div>
        </div>
    );
};

export default PageLoader;
